var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 14,
    stroke: "#F1A128",
    strokeWidth: 3,
    fill: "#FFF8E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40 L20 56 L32 50 L44 56 L40 40",
    stroke: "#F1A128",
    strokeWidth: 3,
    strokeLinejoin: "round",
    fill: "#FFE0A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18 L34.5 24.5 L41.5 25 L36 29.5 L37.5 36.5 L32 33 L26.5 36.5 L28 29.5 L22.5 25 L29.5 24.5 Z",
    fill: "#F1A128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.792bbaf4ae73507902872f1169c6f677.svg";
export { ForwardRef as ReactComponent };